import { StyleSheet } from "react-native";
import { horizontalScale } from "~helpers/basicStyles";

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#fff",
    paddingHorizontal: 20,
    marginHorizontal: 15,
    justifyContent: "center",
    alignSelf: "center",
    borderRadius: 25,
    marginVertical: 10,
    elevation: 8,
    width: "70%",
  },
  headerStyle: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginVertical: 35,
    marginHorizontal: 20,
  },
  viewContainer: {
    marginHorizontal: 20,
  },
  viewStyle: {
    flexDirection: "row",
  },
  heading: {
    fontSize: 25,
    fontFamily: "OpenSans_400Regular",
    fontWeight: "400",
    color: "rgba(0,0,0,1)",
    marginBottom: 2,
  },
  title: {
    fontSize: 20,
    fontFamily: "OpenSans_400Regular",
    fontWeight: "400",
    color: "rgba(0,0,0,1)",
    marginBottom: 20,
  },
  text: {
    marginBottom: 10,
    fontWeight: "700",
    fontSize: 16,
    fontFamily: "OpenSans_400Regular",
  },
  inputstyle: {
    marginBottom: 20,
  },
  input: {
    paddingHorizontal: 15,
  },
  mainView: {
    marginBottom: 20,
  },
  logoStyle: {
    width: horizontalScale(58),
    alignSelf: "center",
  },
  buttonView: {
    marginTop: 30,
    marginBottom: 30,
  },
  button: {
    marginHorizontal: 20,
  },
  imageStyle: {
    width: 190,
    marginBottom: 10,
    height: 190,
  },
  imageView: {
    alignSelf: "center",
  },
  error: {
    color: "red",
  },
});

export default styles;
